export function obterListaTipoOperacaoGovernamental() {
  return (
    [
      { label: '', value: null },
      { label: '1 - Fornecimento com pagamento posterior', value: 'FORNECIMENTOPAGAMENTOPOSTERIOR' },
      { label: '2 - Recebimento do pagamento com fornecimento já realizado', value: 'RECEBIMENTOPAGAMENTOREALIZADO' },
      { label: '3 - Fornecimento com pagamento já realizado', value: 'FORNECIMENTOPAGAMENTOREALIZADO' },
      { label: '4 - Recebimento do pagamento com fornecimento posterior', value: 'RECEBIMENTOPAGAMENTOFORNECIMENTOPOSTERIOR' },
    ]
  );
}
